<canvas id="chart" (mouseout)="onMouseOut()" [height]="diameter + 12" [width]="diameter + 20"></canvas>
